import { createContext } from "react";

const teamContext = createContext();

export default teamContext;